import '../scss/site.scss';

import {App} from './Lib';
const app = new App();

document.addEventListener('DOMContentLoaded',(e)=>{
  app.init();
});
